export default __webpack_public_path__ + "static/media/KhioniyaLovelace.d0fbeb5c.png";